import React from 'react'
import clsx from 'clsx'
import { graphql, useStaticQuery } from 'gatsby'
import { Container, Title, Section, Background } from '../../components/page'
import { CollectionCard } from '../../components/collection'
import { Buttons, LinkButton } from '../../components/button'
import { useSnippets } from '../../components/snippet'
import {
  Swiper,
  SwiperSlide,
  SwiperProps,
  Scrollbar,
} from '../../components/slider'

import * as styles from './top-collections.module.scss'

export type TopCollectionsProps = Queries.TopCollectionsFragment

const swiperProps: SwiperProps = {
  modules: [Scrollbar],
  //loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  breakpoints: {
    576: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
    1400: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
    1900: {
      slidesPerView: 8,
      spaceBetween: 20,
    },
    2500: {
      slidesPerView: 10,
      spaceBetween: 20,
    },
  },
}

export const TopCollections = ({ title, buttons }: TopCollectionsProps) => {
  const data = useStaticQuery<Queries.TopCollectionsStaticQuery>(graphql`
    query TopCollectionsStatic {
      topCollections: allContentfulCollection {
        nodes {
          ...CollectionCard
        }
      }
    }
  `)

  const s = useSnippets()

  return (
    <Section className={styles.section} variant="dark">
      <Container>
        <Title color="light" center className={styles.title}>
          {title}
        </Title>
      </Container>
      <Swiper
        {...swiperProps}
        className={styles.slider}
        scrollbar={{
          el: `.${styles.scrollbar}`,
          draggable: true,
          dragSize: 44,
        }}
      >
        {data.topCollections.nodes.map((c) => (
          <SwiperSlide key={c.id} className={styles.slide}>
            <CollectionCard collection={c} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className={styles.scroller}>
        <div className={clsx('swiper-scrollbar', styles.scrollbar)}>
          <div className={clsx('swiper-scrollbar-drag', styles.scrolldrag)} />
        </div>
      </div>
      <Buttons className={styles.buttons} center>
        {buttons?.map((item, index) => (
          <LinkButton
            key={item?.id}
            link={item}
            color={index === 0 ? 'primary' : 'secondary'}
            variant={index === 0 ? 'border' : null}
            size="lg"
          >
            {item?.title}
          </LinkButton>
        ))}
      </Buttons>
      <Background variant="topcollections" />
    </Section>
  )
}

export const TopCollectionsFragments = graphql`
  fragment TopCollections on ContentfulTopCollections {
    __typename
    id
    title
    buttons {
      ...Link
    }
  }
`
